import api from "../api";
import { GET_ERRORS,GET_EXCHANGERATES, GET_EXCHANGERATE, DELETE_EXCHANGERATE } from "./types";

const FileDownload = require('js-file-download');

export const createExchangeRate = (exchangeRate, history) => async dispatch => {
  try {
    await api.post("/rates/new", exchangeRate);
    history.push("/exchangerate-list");
    dispatch({
      type: GET_ERRORS,
      payload: {}
    });
  } catch (err) {
    dispatch({
      type: GET_ERRORS,
      payload: err.response.data
    });
  }
};

export const updateExchangeRate = (exchangeRate, history) => async dispatch => {
  try {
    await api.put(`/rates/update/${exchangeRate.id}`, exchangeRate);
    history.push("/exchangerate-list");
    dispatch({
      type: GET_ERRORS,
      payload: {}
    });
  } catch (err) {
    dispatch({
      type: GET_ERRORS,
      payload: err.response.data
    });
  }
};

export const getExchangeRates = () => async dispatch => {
  const res = await api.get("/rates/all");
  dispatch({
    type: GET_EXCHANGERATES,
    payload: res.data
    
  });

  dispatch({
    type: GET_ERRORS,
    payload: {}
  });
  
};

export const getExchangeRate = (id, history) => async dispatch => {
  try {
    const res = await api.get(`/rates/by-id/${id}`);
    
    dispatch({
      type: GET_EXCHANGERATE,
      payload: res.data
    });
  } catch (error) {
    
    history.push("/home");
  }
};

export const deleteExchangeRate = id => async dispatch => {
  if (
    window.confirm(
      "Are you sure? This will delete the exchangeRate and all the data related to it"
    )
  ) {
    await api.delete(`/rates/delete/${id}`);
    dispatch({
      type: DELETE_EXCHANGERATE,
      payload: id
    });
  }
};


export const viewRates = exchangeRateId => async dispatch =>  {
 
  const url = "/api/csv/exchangeRate-id/"+exchangeRateId;
 
  api.get(url,{responseType:'blob'}).then((response) => {
      //const data = response.data;

      //Create a Blob from the PDF Stream
      // const file = new Blob(
      //     [response.data]
      //     ,{ type: 'application/csv' });
          FileDownload(response.data, 'rates.csv');
      //Build a URL from the file
     //const fileURL = URL.createObjectURL(file);

      //Open the URL on new Window
      //window.open(fileURL);
      alert("Download completed!")
    
  }).catch(
      function (error) {
        console.log(error)
          alert('An Error occrured please try again')
      }
  );
  }
